import React, { useState, useEffect } from 'react';
import { Tag, Plus, Trash2 } from 'lucide-react';
import api from '../services/api';
import '../styles/AdminComponents.css';

function TagsManagement() {
  const [tags, setTags] = useState([]);
  const [form, setForm] = useState({ name: '', color: '#2196F3' });

  const load = async () => {
    try { setTags((await api.get('/tags')).data); } catch (e) {}
  };
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!form.name.trim()) return;
    try { await api.post('/tags', form); setForm({ name: '', color: '#2196F3' }); load(); }
    catch (e) { alert('Erro'); }
  };
  const remove = async (id) => {
    if (!window.confirm('Excluir tag?')) return;
    await api.delete(`/tags/${id}`); load();
  };

  return (
    <div className="admin-page">
      <h2><Tag size={22}/> Etiquetas (Tags)</h2>
      <p className="muted">Classifique contatos e atendimentos: Lead Quente, Tráfego Pago, Reclamação, B2B etc.</p>

      <div className="card">
        <h3>Nova tag</h3>
        <label>Nome</label>
        <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}/>
        <label>Cor</label>
        <input type="color" value={form.color} onChange={e => setForm({ ...form, color: e.target.value })}/>
        <button onClick={create} className="primary"><Plus size={14}/> Criar</button>
      </div>

      <div className="tags-list">
        {tags.map(t => (
          <span key={t.id} className="tag-chip" style={{ background: t.color }}>
            {t.name}
            <button onClick={() => remove(t.id)}><Trash2 size={12}/></button>
          </span>
        ))}
      </div>
    </div>
  );
}

export default TagsManagement;
